<template>
  <div class="form-floating mb-3">
    <textarea
        @input="handleInput"
        class="form-control"
        placeholder="Leave a comment here"
        :style="`height: ${length}px`"
        :id="property"
        :value="value"
        :class="{'is-invalid': error }"
        :disabled="disabled"
    ></textarea>
    <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
    <message-error :code="errorCode" :hasError="error"/>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'TextareaField',
  components: { MessageError },
  props: {
    value:{ type: String }, 
    property:{ type: String }, 
    name:{ type: String }, 
    error:{ type: Boolean }, 
    length:{ type: String, default: '70'}, 
    disabled:{ type: Boolean,default: false},
    isRequired: { type: Boolean},
    errorCode: { type: String }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
textarea {
  border-radius: 0 !important;
}
</style>
